import { Link, usePage } from "@inertiajs/inertia-react";
import usePageProps from "app/components/hooks/usePageProps";
import Icon from "app/components/Icon";
import InvertedButton, { LinkProps } from "components/Buttons/InvertedButton";
import React from "react";


interface LBProps extends LinkProps {
  href: string;
  text: string;
  showing?: { current: number, max: number }
}

export function LineButton({ href, text, showing, className, ...rest }: LBProps) {

  const {next} = usePageProps< { next?: { page: number } }>()

  return (

      <div className="flex items-center justify-between relative py-32px">
        <Link className="bg-gray-1C1C1C rounded-full text-white p-16px flex gap-15px items-center" href={href} {...rest}>{text} <Icon name="arrow-down"/></Link>
        {showing && <div className="text-16 text-center text-gray-CCCCCC ">Showing <span className="font-semibold">{showing?.current} of {showing?.max}.</span></div>}
      </div>

  );
}
